import { IEditable } from '@/models/IEditable';
import { ICourseInfo, IInstitutionInfo } from '@/models';

export default abstract class LearningEntry implements IEditable {
	public id: number = 0;
	public academicYear: number | null = null;

	public course: ICourseInfo = {
		institutionId: null,
		label: null,
		value: null,
		prefix: null,
		number: null,
	};

	public institution: IInstitutionInfo = {
		institutionId: null,
		label: null,
		value: null,
		logo: null,
		scorePolicy: null,
	};

	public isEditing: boolean = true;
	public isValidating: boolean = false;
	public isPersisting: boolean = false;
}
